import { cmsDataService } from './cms.data.service'

class Api {
    private OmniaApi = '/api/omnia/v1'

    InitialData = this.OmniaApi + '/initialData'
    Page = this.OmniaApi + '/page'
    PageList = this.OmniaApi + '/pageList'
    Extensions = this.OmniaApi + '/extensions'
    FilmExtension = this.OmniaApi + '/extensions/film'
    ConcessionEnabled = this.OmniaApi + '/extensions/ticketing/concession-enabled'
    Configuration = this.OmniaApi + '/configuration'

    private OmniaConnectApi = '/api/omnia/connect/v1'

    GetArcadeCards = '/api/cardwallet'
    AddArcadeCard = (cardNumber: string, pin: string) => `/api/cardwallet?cardNumber=${cardNumber}&pin=${pin}`
    GetArcadeCardBalance = (cardNumber: string, captchaResponse: string) =>
        `/api/cardwallet/balance?cardNumber=${cardNumber}&captcha=${captchaResponse}`
    DeleteArcadeCard = (cardNumber: string) => `/api/cardwallet?cardNumber=${cardNumber}`

    Genres = this.OmniaConnectApi + '/filmGenres'
    Cinemas = this.OmniaConnectApi + '/cinemas'

    Search = (query: string) => '/api/search/results?searchTerm=' + query

    Attributes = (name: string) => this.OmniaConnectApi + '/' + name

    private OmniaFnbApi = '/api/omnia/fnb/v1'
    SoldOutItems = (siteId: string, showDate: string) =>
        this.OmniaFnbApi + `/soldoutitems?siteId=${siteId}&showDate=${showDate}`
    SoldOutItemsQuantity = (siteId: string, showDate: string) =>
        this.OmniaFnbApi + `/soldoutitemsqty?siteId=${siteId}&showDate=${showDate}`

    GetLoyaltyMember = '/api/omnia/v1/member-expiry'

    POST = async <T>(
        url: string,
        model: any,
        allowStringResponse?: boolean
    ): Promise<[data: T | undefined, status: number]> => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model),
        }
        const response = await fetch(url, requestOptions)

        const responseText = await response.text()

        if (allowStringResponse && responseText && response.headers.get('Content-Type').startsWith('text/plain')) {
            return [responseText as T, response.status]
        }

        const data: T = responseText ? JSON.parse(responseText) : undefined

        return [data, response.status]
    }

    DELETE = async <T>(url: string, allowStringResponse?: boolean): Promise<[data: T | undefined, status: number]> => {
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        }
        const response = await fetch(url, requestOptions)

        const responseText = await response.text()

        if (allowStringResponse && responseText && response.headers.get('Content-Type').startsWith('text/plain')) {
            return [responseText as T, response.status]
        }

        const data: T = responseText ? JSON.parse(responseText) : undefined

        return [data, response.status]
    }

    GET = async <T>(
        url: string,
        headers?: any,
        includeCredentials?: boolean,
        allowStringResponse?: boolean
    ): Promise<[data: T, status: number]> => {
        const requestOptions = {
            method: 'GET',
            headers: headers,
            credentials: includeCredentials ? ('include' as RequestCredentials) : ('same-origin' as RequestCredentials),
        }
        const response = await fetch(url, requestOptions)

        const responseText = await response.text()

        if (allowStringResponse && responseText && response.headers.get('Content-Type').startsWith('text/plain')) {
            return [responseText as T, response.status]
        }

        const data: T = responseText ? JSON.parse(responseText) : undefined

        return [data, response.status]
    }
}

export const api = new Api()
